module.exports = __webpack_public_path__ + "static/media/how-you-doing.a36a6212.svg";